export default {
    data: [],
	fetched: false,
};